import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { gtm } from 'apps/gtm';
import { wa, pageEventTypes } from 'apps/analytics';

import FavouritesButton from 'apps/favourites/containers/FavouritesButton';
import ShoppingListsButton from 'apps/shoppingLists/containers/ShoppingListsButton';
import ProductLabel from '../../products/models/ProductLabel';
import FopQuickMenuIcon from './fopPartials/FopQuickMenuIcon';

const shouldExpandQuickMenu = (data, sku, sectionId) => {
  if (!data) {
    return false;
  }

  return (data.sku === sku && data.sectionId === sectionId);
};

export default class FopQuickMenu extends PureComponent {
  static propTypes = {
    addToFavourites: PropTypes.func,
    closeQuickMenu: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    openQuickMenu: PropTypes.func.isRequired,
    openShoppingListsModal: PropTypes.func,
    product: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.object,
      labels: PropTypes.arrayOf(PropTypes.oneOf(Object.values(ProductLabel))),
    }),
    productsPage: PropTypes.object.isRequired,
    // used in container ownProps.productsPageRoute
    // eslint-disable-next-line react/no-unused-prop-types
    productsPageRoute: PropTypes.object.isRequired,
    removeFromFavourites: PropTypes.func,
    router: PropTypes.object.isRequired,
    routeString: PropTypes.string.isRequired,
    sectionId: PropTypes.string.isRequired,
  };

  get isInFavourites() {
    return !!this.props.product.labels && this.props.product.labels.includes(ProductLabel.FAVOURITE);
  }

  open = () => {
    const { product, routeString, sectionId } = this.props;

    this.props.openQuickMenu(routeString, product.sku, sectionId);
    gtm.trigger('gtm:uaEvent', {
      category: 'Quick menu',
      action: 'Menu opened',
    });
    wa.triggerPageEvent(pageEventTypes.QM_OPEN);
  };

  close = () => {
    const { routeString } = this.props;

    this.props.closeQuickMenu(routeString);
    gtm.trigger('gtm:uaEvent', {
      category: 'Quick menu',
      action: 'Menu closed',
    });
    wa.triggerPageEvent(pageEventTypes.QM_CLOSE);
  };

  renderButton() {
    const { product, isLoggedIn } = this.props;
    if (!isLoggedIn) {
      return null;
    }

    return (
      <div className="fop-quickMenu__buttonContainer">
        <button
          className={classNames(
            'fop-quickMenu__button',
            { 'fop-quickMenu__button--inFavourites': this.isInFavourites }
          )}
          onClick={this.open}
          aria-label={`Advanced settings for ${product.name}`}
        >
          <FopQuickMenuIcon />
        </button>
      </div>
    );
  }

  renderQuickMenu() {
    const {
      isLoggedIn,
      product,
      productsPage: { quickMenuExpanded },
      router,
      sectionId,
    } = this.props;

    if (!shouldExpandQuickMenu(quickMenuExpanded, product.sku, sectionId) || !isLoggedIn) {
      return null;
    }

    return (
      <div className="fop-quickMenu__menu">
        <div className="fop-quickMenu__header">
          <h2 className="fop-quickMenu__header--title">
            {product.name}
          </h2>
          <button
            type="button"
            className="fop-quickMenu__header--close"
            onClick={this.close}
            aria-label="Close"
          />
        </div>
        <ul className="fop-quickMenu__options">
          <li className="fop-quickMenu__options--tile">
            <FavouritesButton
              addToFavourites={this.props.addToFavourites}
              inFavourites={this.isInFavourites}
              isLoggedIn={isLoggedIn}
              onFavouritesSuccess={this.close}
              product={product}
              removeFromFavourites={this.props.removeFromFavourites}
              router={router}
            />
          </li>
          <li className="fop-quickMenu__options--tile">
            <ShoppingListsButton
              isLoggedIn={isLoggedIn}
              onShoppingListsModalOpen={this.close}
              openShoppingListsModal={this.props.openShoppingListsModal}
              product={product}
              router={router}
            />
          </li>
        </ul>
      </div>
    );
  }

  render() {
    return (
      <Fragment>
        {this.renderButton()}
        {this.renderQuickMenu()}
      </Fragment>
    );
  }
}
